import React, {Component} from 'react';

import { Row, Col, Button } from 'react-bootstrap';

import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            countries: null,
            firstSessionGt: '',
            firstSessionLt: '',
            tag: '',
            tag1: '',
            tag2: '',
            tag3: '',
            tag4: '',
            tag5: ''
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFieldChange(event) {
        const {value,name} = event.target;

        this.setState({
            [name]: value
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        this.props.onSubmit(this.state);
    }


    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <SelectWrap
                    values={this.props.countries}
                    label="Countries:"
                    name="countries"
                    onChange={this.handleFieldChange}
                    value={this.state.countries}
                    multi
                />

                <Row>
                    <Col lg={6}>
                        <FieldGroup
                            name="firstSessionGt"
                            label="First session GT:"
                            onChange={this.handleFieldChange}
                            value={this.state.firstSessionGt}
                        />
                    </Col>
                    <Col lg={6}>
                        <FieldGroup
                            name="firstSessionLt"
                            label="First session LT:"
                            onChange={this.handleFieldChange}
                            value={this.state.firstSessionLt}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={2}>
                        <FieldGroup
                            name="tag"
                            label="Tag:"
                            onChange={this.handleFieldChange}
                            value={this.state.tag}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            name="tag1"
                            label="Tag1:"
                            onChange={this.handleFieldChange}
                            value={this.state.tag1}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            name="tag2"
                            label="Tag2:"
                            onChange={this.handleFieldChange}
                            value={this.state.tag2}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            name="tag3"
                            label="Tag3:"
                            onChange={this.handleFieldChange}
                            value={this.state.tag3}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            name="tag4"
                            label="Tag4:"
                            onChange={this.handleFieldChange}
                            value={this.state.tag4}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            name="tag5"
                            label="Tag5:"
                            onChange={this.handleFieldChange}
                            value={this.state.tag5}
                        />
                    </Col>
                </Row>
                <Button className="m-b-15" type="submit">Count</Button>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/UsersCount/components/Filters/index.js